import React from 'react';
import { ProductImageWrapper } from './productImage.styled';

interface ProductImageProps {
	productImage: string | null; // Assuming productImage is a URL string or null
}

const ProductImage: React.FC<ProductImageProps> = ({ productImage }) => {
	return (
		productImage && (
			<ProductImageWrapper>
				<img src={productImage} alt="Product" />
			</ProductImageWrapper>
		)
	);
};

export default ProductImage;
